import { useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import { useConsumerName, useCashAppConsumerName, useConsumerSelector } from '../../state'
import { ProfileCardProps } from '../ProfileCard'

export const useProfileCardProps = (): ProfileCardProps => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const profileConsumerName = useConsumerName()
  const cashAppConsumerName = useCashAppConsumerName()
  const { email } = useConsumerSelector()
  const consumerName = profileConsumerName.length > 0 ? profileConsumerName : cashAppConsumerName

  if (isArcadeDesignLanguage) {
    return {
      header: consumerName,
      customSubheader: email,
      hideSubheader: false,
    }
  }

  return {}
}
